import React from 'react'
import PropTypes from 'prop-types'
import { CARD_SIZES } from '@helpers/constants'
import SectionCard from '@components/SectionCard'
import GridColumns from '@components/GridColumns'
import { useResponsive } from '@hooks/useResponsive'

const SectionList = (props) => {
  const { items, inLibraryView } = props
  const { breakpoints } = useResponsive()
  const cols = (() => {
    if (breakpoints.mobile) return 1
    if (breakpoints.wide) return 2
    return 3
  })()

  return (
    <div className={'w-full'}>
      <GridColumns cols={cols}>
        {items.map((section) => (
          <SectionCard
            key={'section' + section.id}
            section={section}
            size={CARD_SIZES.LARGE}
            inLibraryView={inLibraryView}
          />
        ))}
      </GridColumns>
    </div>
  )
}

SectionList.propTypes = {
  items: PropTypes.array,
  inLibraryView: PropTypes.bool,
}

export default SectionList
